
<div class="topbar">
  <ul class="flex ">
    <li *ngFor="let label of ['All', 'This Month', 'Last 30 days', 'Year To Date', 'This Final Year', 'Last Final Year']"
      (click)="onOptionClick(label)" [ngClass]="{ 'active': activeFilter === label }" class="cursor-pointer px-4 py-1">
      {{ label }}
    </li>
    <li class="cursor-pointer px-4 py-1 ">
      <span class="p-input-icon-right">
        <i class="pi pi-calendar-plus"></i>
        <p-calendar [formControl]="dateRange" selectionMode="range" [showButtonBar]="true" [showIcon]="true"
          [iconDisplay]="'input'" placeholder="Select dates" (onSelect)="onDateRangeChange()"></p-calendar>
      </span>
    </li>
  </ul>
</div>





  
